import React, { useState } from "react";
import { Card, Button, CardBody, Row, Col } from "reactstrap";

import DataTable from "react-data-table-component";
import moment from "moment";

function InquiryTable() {
  const data = [
    {
      vin_number: "#54981",
      car_name: "2017 Audi A4 Prestiger",
      leads: 4,
      date: "20-01-2019",
      type: "Old",
      action: {
        edit: true,
        delete: true,
      },
    },
    {
      vin_number: "#25425",
      car_name: "2016 BMW X1",
      leads: 6,
      date: "26-04-2019",
      type: "New",
      action: {
        edit: true,
        delete: true,
      },
    },
    {
      vin_number: "#45678",
      car_name: "2017 Audi Q3 2.0T Prestige",
      leads: 9,
      date: "14-04-2019",
      type: "Old",
      action: {
        edit: true,
        delete: true,
      },
    },
    {
      vin_number: "#47989",
      car_name: "1998 BMW M3",
      leads: 2,
      date: "06-12-2019",
      type: "Old",
      action: {
        edit: true,
        delete: true,
      },
    },
    {
      vin_number: "#12356",
      car_name: "2016 BMW M3 Base",
      leads: 3,
      date: "12-12-2019",
      type: "New",
      action: {
        edit: true,
        delete: true,
      },
    },
    {
      vin_number: "#12345",
      car_name: "2010 BMW M6",
      leads: 5,
      date: "10-02-2019",
      type: "New",
      action: {
        edit: true,
        delete: true,
      },
    },
    // {
    //   vin_number: "#34265",
    //   car_name: "2014 Ford F-150 Lariat",
    //   leads: 9,
    //   date: "30-12-2019",
    //   type: "Old",
    //   action: {
    //     edit: true,
    //     delete: true,
    //   },
    // },
    // {
    //   vin_number: "#15548",
    //   car_name: "2016 Ford Edge Titanium",
    //   leads: 8,
    //   date: "12-12-2019",
    //   type: "New",
    //   action: {
    //     edit: true,
    //     delete: true,
    //   },
    // },
  ];

  const columns = [
    {
      selector: (row) => row.vin_number,
      name: "VIN number",
      sortable: true,
    },
    {
      selector: (row) => row.car_name,
      name: "Car name",
      sortable: true,
    },
    {
      selector: (row) => row.date,
      name: "Date",
      sortable: true,
    },
    {
      selector: (row) => row.type,
      name: "Type",
      sortable: true,
    },
    // {
    //   selector: (row) => row.office,
    //   name: "Office",
    //   sortable: true,
    // },
    // {
    //   selector: (row) => row.salary,
    //   name: "Salary",
    //   sortable: true,
    //   formatter: (cell) => (
    //     <>{Number(cell.replace(/[^0-9.-]+/g, "")).toLocaleString("en-GB")}</>
    //   ),
    // },
  ];
  const customStyles = {
    rows: {
      style: {
        borderBottom: "none !important", // Removes line between rows
      },
    },
  };

  return (
    <>
      <DataTable
        title="Top inquiries"
        columns={columns}
        data={data}
        highlightOnHover
        customStyles={customStyles}
      />
    </>
  );
}

export default InquiryTable;
